import { MultiLanguage } from "../../MultiLanguage";

export class Requirement {
    private _id: string;
    private _title: MultiLanguage;
    private _allowsDocument: boolean;

    constructor(requirement: any) {
        this._id = requirement.id;
        this._title = new MultiLanguage(requirement.title);
        this._allowsDocument = requirement.allowsDocument
    }

    public get id(): string {
        return this._id;
    }
    public get title(): MultiLanguage {
        return this._title;
    }
    public get allowsDocument():boolean{
        return this._allowsDocument;
    }
}